import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  getDefaultSellerDestination,
  isSellerOnboardingComplete,
  isSellerRole,
  SELLER_ONBOARDING_PATH,
} from "../features/auth/onboarding";

const SellerRoute: React.FC = () => {
  const { isAuthReady, user } = useAuth();
  const location = useLocation();

  if (!isAuthReady) {
    return (
      <div className="page-shell flex min-h-[50vh] items-center justify-center">
        <div className="spinner" role="status" aria-label="Loading" />
      </div>
    );
  }

  if (!isSellerRole(user?.role)) {
    return <Navigate to="/" replace />;
  }

  if (!isSellerOnboardingComplete(user)) {
    return (
      <Navigate
        to={SELLER_ONBOARDING_PATH}
        replace
        state={{ from: location.pathname || getDefaultSellerDestination() }}
      />
    );
  }

  return <Outlet />;
};

export default SellerRoute;
